<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="12">
        <AllTable
          ref="allTable"
          :tableData="tableData"
          :loading="loading"
          :tablePage="page"
          @reload="reload"
          @checkbox-change="checkboxChange"
        >
          <page-header
            ref="header"
            slot="header"
            @query="getData"
            @reset="resetPage"
          />
          <pagination
            perfect
            size="mini"
            align="right"
            slot="pager"
            :layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage']"
            :current-page="page.curPage"
            :page-size="page.pageSize"
            :page-total="page.pageTotal"
            @change="handlePaginationChange"
          />
        </AllTable>
      </el-col>
      <el-col :span="12">
        <CheckTable ref="checkTable" :tableData="checkRow" @remove="remove">
          <div class="d-flex align-items-center mb-1" slot="header">
            <div class="side-frame-success mr-2"></div>
            <div>
              <span style="font-size: 14px; color: #606266">
                {{ $l('table_header_chooseTech') || '已选工艺' }}
              </span>
            </div>
          </div>
        </CheckTable>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AllTable from './all-table.vue'
import CheckTable from './check-table.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageHeader, AllTable, CheckTable },
  data() {
    return { usePage: true, checkRow: [] }
  },
  methods: {
    async getData(form) {
      this.loading = true
      const params = { ...form, ...this.page, listPdTechDictStatus: ['Y'] }
      const res = await this.$api
        .pdTechDictionaryListByChooseApi(params)
        .catch(() => null)
      this.loading = false
      this.setData(res)
    },
    checkboxChange(data) {
      const group = data
        .map((item) => {
          const { pdProcessDictStep, techName, techChargeUnit } = item
          return [pdProcessDictStep, techName, techChargeUnit].join('/')
        })
        .reduce((acc, val, i) => {
          acc[val] = (acc[val] || []).concat(data[i])
          return acc
        }, {})

      const keys = Object.keys(group).sort()
      const result = []
      keys.forEach((key) => {
        result.push(...group[key])
      })

      this.checkRow = result || []
      this.$emit('checkbox-change', this.checkRow)
    },
    remove(data) {
      this.$refs.allTable.setCheckboxRow(data, false)
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  border-left: 3px solid $color-success;
  height: 26px;
  margin: 0;
  padding: 0;
}
</style>
